import { useDateRangeContext } from 'features/commonUI'
import { ChartExportClickedProperties, trackChartExportClicked } from 'helpers/chartExport/analytics'
import { CsvCell, toCsvContent } from 'helpers/chartExport/csv'
import { buildChartExportFileName } from 'helpers/chartExport/exportFileName'
import { download } from 'helpers/download'
import { MIMEType } from 'helpers/types'
import { useLDFlag } from 'hooks/launchDarkly'
import { DateTime } from 'luxon'
import { useCallback } from 'react'

export function useIsChartCsvExportEnabled() {
  return useLDFlag('CHART_CSV_EXPORT', false)
}

export type ChartCsvExportOptions = {
  page: string
  widget: string
  qualifier?: string
  widgetType: ChartExportClickedProperties['widget_type']
  rows: CsvCell[][]
  dataRowCount: number
  filtersApplied?: boolean
  from?: DateTime
  to?: DateTime
}

export function useChartCsvExport() {
  const { dateRange } = useDateRangeContext()

  return useCallback(
    ({
      page,
      widget,
      qualifier,
      widgetType,
      rows,
      dataRowCount,
      filtersApplied = false,
      from = dateRange?.startDate,
      to = dateRange?.endDate,
    }: ChartCsvExportOptions) => {
      const fileName = buildChartExportFileName({ page, widget, qualifier, from, to })

      download(toCsvContent(rows), fileName, MIMEType.Csv)

      trackChartExportClicked({
        page,
        widget_type: widgetType,
        dimension_or_granularity: qualifier,
        row_count: dataRowCount,
        date_range_days: from != null && to != null ? Math.round(to.diff(from, 'days').days) : undefined,
        filters_applied: filtersApplied,
      })
    },
    [dateRange?.endDate, dateRange?.startDate]
  )
}
